module.exports = __webpack_public_path__ + "static/media/location3.86aca9af.png";